// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"fccda594","654":"e6d384d0","787":"7f5d0b19"}[chunkId] + ".chunk.js";
};